import { ANALYTICS } from '@/constants/analytics/analytics';
import { COOKIE_KEYS, IGtmIdentifiers } from '@/constants/storage/cookies';
import { cookiesUtils } from '@/utils/storage/cookies';

export type DataLayerAttributes = Record<string, any>;

declare global {
  interface Window {
    dataLayer: DataLayerAttributes[];
  }
}

/**
 * Pushes attributes to Google Tag Manager dataLayer
 */
export const addToDataLayer = (attributes: DataLayerAttributes): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(attributes);
};

// gtm loads async, so callers must read this per event and never cache it
export const getGtmIdentifiersAttributes = (): Record<
  string,
  string | null
> => {
  let parsed: Partial<IGtmIdentifiers> = {};
  try {
    parsed = JSON.parse(
      cookiesUtils.getCookie(COOKIE_KEYS.GA_IDENTIFIERS) ?? '{}'
    );
  } catch {}
  return {
    [ANALYTICS.PROPERTIES.GA_USER_PSEUDO_ID]: parsed?.ga_fpid ?? null,
    [ANALYTICS.PROPERTIES.GA_SESSION_ID]: parsed?.ga_session_id ?? null,
  };
};
